import { useRef } from "react";
import { useSignal, useSignalEffect } from "@preact/signals-react";
import { draggable, dropTargetForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";
import { combine } from "@atlaskit/pragmatic-drag-and-drop/combine";
import NGUser from "./NGUser";

export default function NGUserContainer({ Users, ThemeMode }) {
  const ref = useRef(null);
  const handleRef = useRef(null);
  const dragging = useSignal<boolean>(false);
  const position = useSignal<{ right: number; bottom: number } | null>(null);
  const backgroundColor = ThemeMode === "dark" ? "#121212" : "white";
  const draggingColor = ThemeMode === "dark" ? "#888" : "#ccc";

  useSignalEffect(() => {
    const element = ref.current;
    const dragHandle = handleRef.current;

    if (!element || !dragHandle) return;

    return combine(
      draggable({
        element,
        dragHandle,
        getInitialData: () => ({ type: "my-draggable" }),
        onDragStart: () => {
          console.log("drag started");
          dragging.value = true;
        },
        onDrop: () => {
          console.log("drag ended");
          dragging.value = false;
        },
      }),
      dropTargetForElements({
        element,
        getData: () => ({ name: "drop-anywhere" }),
        onDragEnter: () => console.log("entered drop zone"),
        onDragLeave: () => console.log("left drop zone"),
        onDrop: ({ location }) => {
          console.log("Dropped at:", location.current.input.clientX, location.current.input.clientY);
          const { clientX, clientY } = location.current.input;
          const right = window.innerWidth - clientX;
          const bottom = window.innerHeight - clientY;
          position.value = { right, bottom };
        },
      })
    );
  });

  return (
    <div
      ref={ref}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        pointerEvents: dragging.value ? "auto" : "none",
      }}
      data-testid="sync-user-container"
    >
      <div
        ref={handleRef}
        style={{
          position: "fixed",
          right: position.value?.right ?? "20px",
          bottom: position.value?.bottom ?? "20px",
          padding: "1rem",
          backgroundColor: dragging.value ? draggingColor : backgroundColor,
          border: `1px solid ${ThemeMode === "dark" ? "white" : "#121212"}`,
          color: "white",
          cursor: "grab",
          borderRadius: "8px",
          zIndex: 1001,
          pointerEvents: "auto",
          ...(position.value?.right && { transform: "translate(50%, 50%)" }),
        }}
      >
        <NGUser Users={Users} />
      </div>
    </div>
  );
}
